<template>
  <el-table-column
    prop="completed_at"
    sortable="custom"
    label="Teljesítés dátuma"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      {{ scope.row.completed_at | date }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'completed_at',
};
</script>
